"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FirmaFeeGrantService = void 0;
var feegrant_1 = require("./firmachain/feegrant");
var FirmaUtil_1 = require("./FirmaUtil");
var FeeGrantTxTypes_1 = require("./firmachain/feegrant/FeeGrantTxTypes");
var FeeGrantQueryClient_1 = require("./firmachain/feegrant/FeeGrantQueryClient");
var any_1 = require("./firmachain/google/protobuf/any");
var FirmaFeeGrantService = /** @class */ (function () {
    function FirmaFeeGrantService(config) {
        this.config = config;
    }
    FirmaFeeGrantService.prototype.getGasEstimationRevokeAllowance = function (wallet, granteeAddress, txMisc) {
        if (txMisc === void 0) { txMisc = FirmaUtil_1.DefaultTxMisc; }
        return __awaiter(this, void 0, void 0, function () {
            var txRaw, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        return [4 /*yield*/, this.getSignedTxRevokeAllowance(wallet, granteeAddress, txMisc)];
                    case 1:
                        txRaw = _a.sent();
                        return [4 /*yield*/, FirmaUtil_1.FirmaUtil.estimateGas(txRaw)];
                    case 2: return [2 /*return*/, _a.sent()];
                    case 3:
                        error_1 = _a.sent();
                        FirmaUtil_1.FirmaUtil.printLog(error_1);
                        throw error_1;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    FirmaFeeGrantService.prototype.getSignedTxRevokeAllowance = function (wallet, granteeAddress, txMisc) {
        if (txMisc === void 0) { txMisc = FirmaUtil_1.DefaultTxMisc; }
        return __awaiter(this, void 0, void 0, function () {
            var address, feeGrantTxClient, message, error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        return [4 /*yield*/, wallet.getAddress()];
                    case 1:
                        address = _a.sent();
                        feeGrantTxClient = new feegrant_1.FeeGrantTxClient(wallet, this.config.rpcAddress);
                        message = feegrant_1.FeeGrantTxClient.msgRevokeAllowance({ granter: address, grantee: granteeAddress });
                        return [4 /*yield*/, feeGrantTxClient.sign([message], FirmaUtil_1.getSignAndBroadcastOption(this.config.denom, txMisc))];
                    case 2: return [2 /*return*/, _a.sent()];
                    case 3:
                        error_2 = _a.sent();
                        FirmaUtil_1.FirmaUtil.printLog(error_2);
                        throw error_2;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    FirmaFeeGrantService.prototype.revokeAllowance = function (wallet, granteeAddress, txMisc) {
        if (txMisc === void 0) { txMisc = FirmaUtil_1.DefaultTxMisc; }
        return __awaiter(this, void 0, void 0, function () {
            var txRaw, feeGrantTxClient, error_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        return [4 /*yield*/, this.getSignedTxRevokeAllowance(wallet, granteeAddress, txMisc)];
                    case 1:
                        txRaw = _a.sent();
                        feeGrantTxClient = new feegrant_1.FeeGrantTxClient(wallet, this.config.rpcAddress);
                        return [4 /*yield*/, feeGrantTxClient.broadcast(txRaw)];
                    case 2: return [2 /*return*/, _a.sent()];
                    case 3:
                        error_3 = _a.sent();
                        FirmaUtil_1.FirmaUtil.printLog(error_3);
                        throw error_3;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    FirmaFeeGrantService.prototype.getCoinType = function (amount) {
        if (amount == undefined)
            return [];
        return [{ denom: this.config.denom, amount: amount.toString() }];
    };
    FirmaFeeGrantService.prototype.getGasEstimationGrantPeriodicAllowance = function (wallet, granteeAddress, feegrantOption, txMisc) {
        if (txMisc === void 0) { txMisc = FirmaUtil_1.DefaultTxMisc; }
        return __awaiter(this, void 0, void 0, function () {
            var txRaw, error_4;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        return [4 /*yield*/, this.getSignedTxGrantPeriodicAllowance(wallet, granteeAddress, feegrantOption, txMisc)];
                    case 1:
                        txRaw = _a.sent();
                        return [4 /*yield*/, FirmaUtil_1.FirmaUtil.estimateGas(txRaw)];
                    case 2: return [2 /*return*/, _a.sent()];
                    case 3:
                        error_4 = _a.sent();
                        FirmaUtil_1.FirmaUtil.printLog(error_4);
                        throw error_4;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    FirmaFeeGrantService.prototype.getSignedTxGrantPeriodicAllowance = function (wallet, granteeAddress, feegrantOption, txMisc) {
        if (txMisc === void 0) { txMisc = FirmaUtil_1.DefaultTxMisc; }
        return __awaiter(this, void 0, void 0, function () {
            var address, feeGrantTxClient, periodicAllowanceData, bytes, allowanceAnyData, message, error_5;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        return [4 /*yield*/, wallet.getAddress()];
                    case 1:
                        address = _a.sent();
                        feeGrantTxClient = new feegrant_1.FeeGrantTxClient(wallet, this.config.rpcAddress);
                        periodicAllowanceData = {
                            basic: {
                                spendLimit: this.getCoinType(feegrantOption.basicSpendLimit),
                                expiration: feegrantOption.basicExpiration
                            },
                            period: { seconds: feegrantOption.periodSeconds, nanos: 0 },
                            periodSpendLimit: [{ denom: this.config.denom, amount: feegrantOption.periodSpendLimit.toString() }],
                            periodCanSpend: [{ denom: this.config.denom, amount: feegrantOption.periodCanSpend.toString() }],
                            periodReset: feegrantOption.periodReset
                        };
                        bytes = FeeGrantTxTypes_1.PeriodicAllowance.encode(periodicAllowanceData).finish();
                        allowanceAnyData = {
                            typeUrl: "/cosmos.feegrant.v1beta1.PeriodicAllowance",
                            value: bytes
                        };
                        message = feegrant_1.FeeGrantTxClient.msgGrantAllowance({
                            granter: address,
                            grantee: granteeAddress,
                            allowance: any_1.Any.fromJSON(allowanceAnyData)
                        });
                        return [4 /*yield*/, feeGrantTxClient.sign([message], FirmaUtil_1.getSignAndBroadcastOption(this.config.denom, txMisc))];
                    case 2: return [2 /*return*/, _a.sent()];
                    case 3:
                        error_5 = _a.sent();
                        FirmaUtil_1.FirmaUtil.printLog(error_5);
                        throw error_5;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    FirmaFeeGrantService.prototype.getGasEstimationGrantBasicAllowance = function (wallet, granteeAddress, feegrantOption, txMisc) {
        if (feegrantOption === void 0) { feegrantOption = feegrant_1.DefaultBasicFeeGrantOption; }
        if (txMisc === void 0) { txMisc = FirmaUtil_1.DefaultTxMisc; }
        return __awaiter(this, void 0, void 0, function () {
            var txRaw, error_6;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        return [4 /*yield*/, this.getSignedTxGrantBasicAllowance(wallet, granteeAddress, feegrantOption, txMisc)];
                    case 1:
                        txRaw = _a.sent();
                        return [4 /*yield*/, FirmaUtil_1.FirmaUtil.estimateGas(txRaw)];
                    case 2: return [2 /*return*/, _a.sent()];
                    case 3:
                        error_6 = _a.sent();
                        FirmaUtil_1.FirmaUtil.printLog(error_6);
                        throw error_6;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    FirmaFeeGrantService.prototype.getSignedTxGrantBasicAllowance = function (wallet, granteeAddress, feegrantOption, txMisc) {
        if (feegrantOption === void 0) { feegrantOption = feegrant_1.DefaultBasicFeeGrantOption; }
        if (txMisc === void 0) { txMisc = FirmaUtil_1.DefaultTxMisc; }
        return __awaiter(this, void 0, void 0, function () {
            var feeGrantTxClient, address, basicAllowanceData, bytes, allowanceAnyData, message, error_7;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        feeGrantTxClient = new feegrant_1.FeeGrantTxClient(wallet, this.config.rpcAddress);
                        return [4 /*yield*/, wallet.getAddress()];
                    case 1:
                        address = _a.sent();
                        basicAllowanceData = {
                            spendLimit: this.getCoinType(feegrantOption.spendLimit),
                            expiration: feegrantOption.expiration
                        };
                        bytes = FeeGrantTxTypes_1.BasicAllowance.encode(basicAllowanceData).finish();
                        allowanceAnyData = {
                            typeUrl: "/cosmos.feegrant.v1beta1.BasicAllowance",
                            value: bytes
                        };
                        message = feegrant_1.FeeGrantTxClient.msgGrantAllowance({
                            granter: address,
                            grantee: granteeAddress,
                            allowance: any_1.Any.fromJSON(allowanceAnyData)
                        });
                        return [4 /*yield*/, feeGrantTxClient.sign([message], FirmaUtil_1.getSignAndBroadcastOption(this.config.denom, txMisc))];
                    case 2: return [2 /*return*/, _a.sent()];
                    case 3:
                        error_7 = _a.sent();
                        FirmaUtil_1.FirmaUtil.printLog(error_7);
                        throw error_7;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    FirmaFeeGrantService.prototype.grantPeriodicAllowance = function (wallet, granteeAddress, feegrantOption, txMisc) {
        if (txMisc === void 0) { txMisc = FirmaUtil_1.DefaultTxMisc; }
        return __awaiter(this, void 0, void 0, function () {
            var txRaw, feeGrantTxClient, error_8;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        return [4 /*yield*/, this.getSignedTxGrantPeriodicAllowance(wallet, granteeAddress, feegrantOption, txMisc)];
                    case 1:
                        txRaw = _a.sent();
                        feeGrantTxClient = new feegrant_1.FeeGrantTxClient(wallet, this.config.rpcAddress);
                        return [4 /*yield*/, feeGrantTxClient.broadcast(txRaw)];
                    case 2: return [2 /*return*/, _a.sent()];
                    case 3:
                        error_8 = _a.sent();
                        FirmaUtil_1.FirmaUtil.printLog(error_8);
                        throw error_8;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    FirmaFeeGrantService.prototype.grantBasicAllowance = function (wallet, granteeAddress, feegrantOption, txMisc) {
        if (feegrantOption === void 0) { feegrantOption = feegrant_1.DefaultBasicFeeGrantOption; }
        if (txMisc === void 0) { txMisc = FirmaUtil_1.DefaultTxMisc; }
        return __awaiter(this, void 0, void 0, function () {
            var txRaw, feeGrantTxClient, error_9;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        return [4 /*yield*/, this.getSignedTxGrantBasicAllowance(wallet, granteeAddress, feegrantOption, txMisc)];
                    case 1:
                        txRaw = _a.sent();
                        feeGrantTxClient = new feegrant_1.FeeGrantTxClient(wallet, this.config.rpcAddress);
                        return [4 /*yield*/, feeGrantTxClient.broadcast(txRaw)];
                    case 2: return [2 /*return*/, _a.sent()];
                    case 3:
                        error_9 = _a.sent();
                        FirmaUtil_1.FirmaUtil.printLog(error_9);
                        throw error_9;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    // query
    FirmaFeeGrantService.prototype.getGranteeAllowance = function (granterAddress, granteeAddress) {
        return __awaiter(this, void 0, void 0, function () {
            var queryClient, result, error_10;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        queryClient = new FeeGrantQueryClient_1.FeeGrantQueryClient(this.config.restApiAddress);
                        return [4 /*yield*/, queryClient.getGranteeAllowance(granterAddress, granteeAddress)];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result];
                    case 2:
                        error_10 = _a.sent();
                        FirmaUtil_1.FirmaUtil.printLog(error_10);
                        throw error_10;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    FirmaFeeGrantService.prototype.getGranteeAllowanceAll = function (granteeAddress) {
        return __awaiter(this, void 0, void 0, function () {
            var queryClient, result, error_11;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        queryClient = new FeeGrantQueryClient_1.FeeGrantQueryClient(this.config.restApiAddress);
                        return [4 /*yield*/, queryClient.getGranteeAllowanceAll(granteeAddress)];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result];
                    case 2:
                        error_11 = _a.sent();
                        FirmaUtil_1.FirmaUtil.printLog(error_11);
                        throw error_11;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    return FirmaFeeGrantService;
}());
exports.FirmaFeeGrantService = FirmaFeeGrantService;
